import React from "react";
import {
  ArrowDown,
  ArrowRight,
  ArrowUp,
  Minus,
  TrendingDown,
  TrendingUp,
  UserCircle,
} from "lucide-react";
import {
  formatOddsChangedAt,
  formatOddsValue,
  getOddsMove,
} from "../../utils/oddsHistoryHelpers";

const MOVE_ICON = {
  up: TrendingUp,
  down: TrendingDown,
  flat: Minus,
  neutral: ArrowRight,
};

const OddsHistoryOutcomeCard = ({ group, layout = "default" }) => {
  const move = getOddsMove(group.latest);
  const MoveIcon = MOVE_ICON[move.tone] || ArrowRight;
  const visibleEntries = group.entries.slice(0, layout === "workspace" ? 8 : 5);

  return (
    <article
      className={`oh-outcome oh-outcome-${move.tone}${
        layout === "workspace" ? " oh-outcome-workspace" : ""
      }`}
    >
      <div className="oh-outcome-accent" aria-hidden />

      <header className="oh-outcome-head">
        <span className="oh-outcome-icon">
          <MoveIcon size={15} aria-hidden />
        </span>
        <div className="oh-outcome-copy">
          <h3>{group.outcomeLabel}</h3>
          <p>
            {group.count} change{group.count === 1 ? "" : "s"} · {group.upMoves} up ·{" "}
            {group.downMoves} down
          </p>
        </div>
        <span className={`oh-move-pill oh-move-pill-${move.tone}`}>{move.label}</span>
      </header>

      <div className="oh-latest-panel">
        <div className="oh-odds-box">
          <span className="oh-odds-label">Before</span>
          <strong className="oh-odds-value oh-odds-old tabular-nums">
            {formatOddsValue(group.latest?.oldOdds)}
          </strong>
        </div>
        <span className="oh-odds-arrow" aria-hidden>
          <ArrowRight size={14} />
        </span>
        <div className="oh-odds-box">
          <span className="oh-odds-label">Now</span>
          <strong className="oh-odds-value oh-odds-new tabular-nums">
            {formatOddsValue(group.latest?.newOdds)}
          </strong>
        </div>
      </div>

      <div className="oh-operator-row">
        <UserCircle size={14} aria-hidden />
        <strong>{group.latest?.changedBy?.name || "Operator"}</strong>
        <span className="oh-operator-dot" aria-hidden />
        <time dateTime={group.latest?.changedAt}>
          {formatOddsChangedAt(group.latest?.changedAt)}
        </time>
      </div>

      <div className="oh-trail">
        <div className="oh-trail-head">
          <span>Recent trail</span>
          {group.count > visibleEntries.length ? (
            <em>+{group.count - visibleEntries.length} older</em>
          ) : null}
        </div>
        <ul className="oh-trail-list">
          {visibleEntries.map((entry, idx) => {
            const entryMove = getOddsMove(entry);
            return (
              <li key={entry._id || `${group.outcomeKey}-${idx}`}>
                <span className={`oh-trail-dot oh-trail-dot-${entryMove.tone}`} aria-hidden />
                <time dateTime={entry.changedAt}>
                  {formatOddsChangedAt(entry.changedAt, { short: true })}
                </time>
                <span className="oh-trail-delta">
                  <span className="oh-odds-old tabular-nums">{formatOddsValue(entry.oldOdds)}</span>
                  <ArrowRight size={10} aria-hidden />
                  <span className="oh-odds-new tabular-nums">{formatOddsValue(entry.newOdds)}</span>
                </span>
              </li>
            );
          })}
        </ul>
      </div>
    </article>
  );
};

export default OddsHistoryOutcomeCard;
